import { createSignalRConnection, startConnection } from "./signalRConnection";
import store from "../../store/store"
import { getAllNotifications, getTopPagesNotificationsCounts } from "../../features/notification/notificationSlice";
import { setLoadItemSelect } from "../../features/loadList/loadListSlice";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { addLiveLocationDataToShipmentItemLocationList } from "../../features/topPagesMap/topPagesMapSlice";
import { updateSignalRSupportChatList } from "../../features/messages/messageSlice";
import { showNestedModal } from "../../features/modal/modalSlice";

const Tst = ({type, path}) => {


    return (
        <div>
            <Link to={path}>
                {
                    type === "yuklemede" && "Yükünüz sürücü tarafından onaylanıp yüklemede aşamasına geçmiştir, görüntülemek için tıklayın."
                }
                {
                    type === "seferde" && "Yükünüz seferde aşamasına geçmiştir, görüntülemek için tıklayın."
                }
                {
                    type === "bosaltmada" && "Yükünüz boşaltmada aşamasına geçmiştir, görüntülemek için tıklayın."
                }
                {
                    type === "tamamlanan" && "Yükünüzün sevkiyatı tamamlanmıştır, görüntülemek için tıklayın."
                }
                {
                    type === "toplu" && "Toplu yükleriniz eklenmiştir, görüntülemek için tıklayın."
                }

            </Link>
        </div>
    )
}

const ToastContent = () => (
    <p onClick={() => store.dispatch(showNestedModal("allLoadBulk"))}>Toplu yük ekleme işlemi gerçekleştirildi, sonuçları görmek için tıklayınız.</p>
);

const connectionOn = async () => {
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const userId = JSON.parse(storage.getItem("userId"))
    const connection = createSignalRConnection(userId)
    await startConnection(connection)

    //! teklif gelince bildirim sayılarını yeniler
    connection.on('ViewOfIncomingAspireds', (data) => {
        store.dispatch(setLoadItemSelect(data?.waitingLoad.id)); 
        store.dispatch(getTopPagesNotificationsCounts({companyList: []}))

        store.dispatch(getAllNotifications())
    });
    //! kamyoncu onayından sonra çalışıyor
    connection.on('driverAprovedAspiredLoad', (data) => {

        store.dispatch(setLoadItemSelect(data?.waitingLoad.id)); 
        store.dispatch(getTopPagesNotificationsCounts({companyList: []}))

        store.dispatch(getAllNotifications())

        toast.info(<Tst type={"yuklemede"} path={"/yuklemede"}/>, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    });
    //! yüklemeden seferdeye geçerken çalışıyor
    connection.on('fromInstallationToExpedition', (data) => {

        store.dispatch(setLoadItemSelect(data?.waitingLoad.id)); 
        store.dispatch(getTopPagesNotificationsCounts({companyList: []}))

        store.dispatch(getAllNotifications())

        toast.info(<Tst type={"seferde"} path={"/seferde"}/>, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    });
    //! seferdeden boşaltmaya geçerken çalışıyor
    connection.on('fromExpeditionToUnloading', (data) => {

        store.dispatch(setLoadItemSelect(data?.waitingLoad.id)); 
        store.dispatch(getTopPagesNotificationsCounts({companyList: []}))

        store.dispatch(getAllNotifications())

        toast.info(<Tst type={"bosaltmada"} path={"/bosaltmada"}/>, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    });
    //! tamamlandığında
    connection.on('fromUnloadingToCompletedExpedition', (data) => {

        store.dispatch(setLoadItemSelect(data?.waitingLoad.id)); 
        store.dispatch(getTopPagesNotificationsCounts({companyList: []}))

        store.dispatch(getAllNotifications())

        toast.info(<Tst type={"tamamlanan"} path={"/tamamlanan-seferler"}/>, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    });


    //! liveYuklemeLocation
    connection.on('liveYuklemeLocation', (data) => {
        store.dispatch(addLiveLocationDataToShipmentItemLocationList({
            lastLiveLocationData: {...data.shipmentLocation.shipmentLocation, createdDate: data.shipmentLocation.shipmentLocation.createdDate}
        }))
    });

    //! liveSeferdeLocation
    connection.on('liveSeferdeLocation', (data) => {
        store.dispatch(addLiveLocationDataToShipmentItemLocationList({
            lastLiveLocationData: {...data.shipmentLocation.shipmentLocation, createdDate: data.shipmentLocation.shipmentLocation.createdDate}
        }))
    });

    //! liveBosaltmadaLocation
    connection.on('liveBosaltmadaLocation', (data) => {
        store.dispatch(addLiveLocationDataToShipmentItemLocationList({
            lastLiveLocationData: {...data.shipmentLocation.shipmentLocation, createdDate:  data.shipmentLocation.shipmentLocation.createdDate}
        }))

    });

    //! mesaj bildirimleri
    connection.on("ReceiveSupportChatMessage", (data) => {
        store.dispatch(updateSignalRSupportChatList(data))
    })

    //! toplu yük ekleme bildirim
    connection.on("ReceiveBulkResult", (data) => {
        
        toast.info(<ToastContent />, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            // closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        
    })
    
}

export default connectionOn
